import { toast } from "sonner";
import { Copy, Link2, RefreshCw } from "lucide-react";
import { Switch } from "./ui/switch";
import { http, formatApiError } from "../lib/api";

const LABELS = { apply: ["Postuler", "Option Candidats"], quote: ["Demande de devis", "Option Devis & demandes de devis"] };
const copy = (u) => navigator.clipboard?.writeText(u).then(() => toast.success("Lien copié"), () => window.prompt("Lien :", u));

const Url = ({ url, testid, muted }) => (
  <span className={`inline-flex items-center gap-1 text-xs break-all ${muted ? "text-slate-500" : "text-sky-700"}`}>{url}
    <button type="button" onClick={() => copy(url)} className="p-1 rounded hover:bg-sky-50" aria-label="Copier le lien" data-testid={testid}><Copy className="h-3.5 w-3.5" /></button>
  </span>
);

const LinkRow = ({ form, s, canEdit, toggle, slug }) => {
  const [title, opt] = LABELS[form];
  const why = !s.module_active ? `${opt} non active` : !s.switch ? "Désactivé manuellement" : !s.active ? "Entreprise inactive" : "En ligne";
  return (
    <div className="py-3 border-b border-slate-100 last:border-0" data-testid={`public-link-${form}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="font-semibold text-sm w-40">{title}</span>
        <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${s.active ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-600"}`} data-testid={`public-link-state-${form}`}>{why}</span>
        <label className="ml-auto inline-flex items-center gap-2 text-xs text-slate-600">Interrupteur
          <Switch checked={s.switch} disabled={!canEdit} onCheckedChange={(v) => toggle(form, v)} data-testid={`public-link-toggle-${form}`} /></label>
      </div>
      <div className="mt-1 space-y-0.5">
        <Url url={s.url} testid={`public-link-copy-${form}-${slug}`} />
        {s.legacy_url && <div className="text-[11px] text-slate-500">Ancien lien (toujours actif, mêmes réglages) : <Url url={s.legacy_url} muted testid={`public-link-legacy-${form}`} /></div>}
      </div>
    </div>
  );
};

export const PublicLinksBlock = ({ company, canEdit, onChanged }) => {
  const run = (p, ok) => p.then((r) => { toast.success(ok); onChanged(r.data); }, (e) => toast.error(formatApiError(e)));
  const toggle = (form, v) => run(http.post(`/superadmin/companies/${company.id}/public-forms`, { [form]: v }), v ? "Lien activé" : "Lien désactivé");
  const regen = () => window.confirm("Générer un nouveau lien ? Les anciens liens à code ne fonctionneront plus.") && run(http.post(`/superadmin/companies/${company.id}/public-key`), "Nouveaux liens générés");
  return (
    <section className="mt-6 border border-slate-200 rounded-md p-4" data-testid="public-links-block">
      <div className="flex flex-wrap items-center gap-3 mb-1">
        <h3 className="font-display font-bold text-lg flex items-center gap-2"><Link2 className="h-5 w-5 text-[#C9962E]" />Pages publiques de l'entreprise</h3>
        <span className="text-xs text-slate-600">Code client : <b className="font-mono" data-testid="company-client-code">{company.client_code}</b></span>
        {canEdit && <button type="button" onClick={regen} className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-slate-600 hover:text-slate-900" data-testid="public-links-regen"><RefreshCw className="h-3.5 w-3.5" />Nouveau lien</button>}
      </div>
      <p className="text-[11px] text-slate-500">Les candidatures et demandes reçues par ces liens arrivent dans l'espace de l'entreprise. Pages propriété de Solutions PRIME.</p>
      {Object.keys(LABELS).map((k) => <LinkRow key={k} form={k} s={company.public_links[k]} canEdit={canEdit} toggle={toggle} slug={company.slug} />)}
    </section>
  );
};
